import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClientProviders } from '@/providers/client-providers';
import { AppRouter } from '@/src/router';
import '@/app/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ClientProviders>
      <AppRouter />
    </ClientProviders>
  </BrowserRouter>
);
